/**
 * Frequency Master Data Interfaces
 * Framework-agnostic TypeScript interfaces for Frequency management
 */

export interface Frequency {
  id: number;
  frequency_name: string;
  program_id: number;
  status: number;
  created_at?: string;
  updated_at?: string;
}

export interface FrequencyFormData {
  frequency_name: string;
  program_id: number;
  status: number;
  id?: number;
}

export interface FrequencyApiResponse {
  status: number;
  data: Frequency[];
  body?: {
    data: {
      message?: string;
    };
  };
}
